import { ProjectsService } from './projects.service';
import { GooglePlacesService } from './google-places.service';
import { RouterParams } from './router-params.service';
import { AnalyticsService } from './analytics.service';

// Declare all services that will going to be used as shared service
// this declaration could be foind in the shared app module
export function SharedServices() {
  return [
    ProjectsService,
    GooglePlacesService,
    RouterParams,
    AnalyticsService
  ];
}
